import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import { Link } from 'react-router-dom'

import { getDocumentRoute } from '../../../utils/workflowDocuments'

// Chooser for a workflow card that leads to more than one document.
const RelatedDocumentsModal = ({ documents, onHide }) => (
  <Modal show={!!(documents && documents.length)} onHide={onHide} centered>
    <Modal.Header closeButton>
      <Modal.Title as='h5' className='fw-bold'>Open a document</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div className='d-grid gap-2'>
        {(documents || []).map((doc) => (
          <Button
            key={`${doc.type}:${doc.id}`}
            as={Link}
            to={getDocumentRoute(doc)}
            variant='outline-primary'
            className='text-start'
            onClick={onHide}
          >
            {doc.label}
          </Button>
        ))}
      </div>
    </Modal.Body>
  </Modal>
)

export default RelatedDocumentsModal
